export default function(){var isLoading=ref(false);var status=ref('');return{isLoading:isLoading,status:status};}